import L from "leaflet";
import markerIcon from "assets/leaflet/imgs/marker-icon.svg";
import markerIconActive from "assets/leaflet/imgs/marker-icon-active.svg";
import { Marker } from "react-leaflet";
import { GipContext } from "state";
import { useContext } from "react";
import { useGTM } from "hooks";

var LeafIcon = L.Icon.extend({
  options: {
    iconSize: [25, 40],
    shadowSize: [25, 41],
    iconAnchor: [12.5, 37],
    shadowAnchor: [4, 41],
    popupAnchor: [-3, -76],
  },
});

export default function CeficMarker({
  children,
  icon,
  projectId,
  projectName,
  countryId,
  active = false,
  ...props
}) {
  const { dataLayer } = useGTM();
  const MarkerIcon = new LeafIcon({
    iconUrl: active ? markerIconActive : markerIcon,
    className: active
      ? "leaflet-marker-icon leaflet-zoom-animated leaflet-interactive drop-shadow-md"
      : "leaflet-marker-icon leaflet-zoom-animated leaflet-interactive drop-shadow-md !opacity-80",
  });

  const {
    map,
    setActiveProject,
    setShowProjectList,
    setHoverProject,
    setMarkerClicked,
  } = useContext(GipContext);
  return (
    <Marker
      icon={MarkerIcon}
      eventHandlers={{
        click: (e) => {
          dataLayer.push({
            event: "cefic_gip_map.map.marker.click",
            projectId: projectId,
            project: projectName,
          });
          map.flyTo(props.position, 7);
          setActiveProject(projectId, countryId);
          setShowProjectList(false);
          setMarkerClicked(true);
        },
        mouseover: (e) => {
          setHoverProject(projectId, countryId);
        },
        mouseout: (e) => {
          setHoverProject(null);
        },
      }}
      {...props}
    >
      {props.children}
    </Marker>
  );
}
